import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home.component';
import { AppsComponent } from './pages/apps.component';
import { SessionsComponent } from './pages/sessions.component';
import { ChangePasswordComponent } from './pages/change-password.component';
import { ForceChangePasswordComponent } from './pages/force-change-password.component';
import { ProfileComponent } from './pages/profile.component';
import { HrDemoComponent } from './pages/hr-demo.component';
import { PermissionGuard } from './core/permission.guard';
import { AuthGuard } from './core/auth.guard';
import { PortalRedirectGuard } from './core/portal-redirect.guard';
import { LoginComponent } from './pages/login.component';
import { LogoutCallbackComponent } from './pages/logout-callback.component';
import { LayoutComponent } from './pages/admin/layout/admin-layout.component';
import { LoginAttemptsPage } from './pages/admin/audit/login-attempts.page';
import { GroupsPage } from './pages/admin/groups/groups.page';
import { PermissionsPage } from './pages/admin/permissions/permissions.page';
import { RolesPage } from './pages/admin/roles/roles.page';
import { RolePermissionsPage } from './pages/admin/roles/role-permissions.page';
import { SessionsAdminPage } from './pages/admin/sessions/sessions-admin.page';
import { SettingsPage } from './pages/admin/settings/settings.page';
import { SystemsPage } from './pages/admin/systems/systems.page';
import { SystemOwnerPage } from './pages/admin/system-owner/system-owner.page';
import { UsersPage } from './pages/admin/users/users.page';

export const APP_ROUTES: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'force-change-password', component: ForceChangePasswordComponent },
  { path: 'logout-callback', component: LogoutCallbackComponent },

  {
    path: 'hr',
    component: HrDemoComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: { permission: 'hr:employees.read' },
  },
  {
    path: '',
    component: LayoutComponent,
    // PortalRedirectGuard (بعد AuthGuard): مستخدمو البوابات الخارجية يُحوَّلون دائماً
    // إلى تطبيقهم ولا يرون البوابة المركزية (صفحة الدخول وحدها مستثناة لأنها خارج هذا المسار).
    canActivate: [AuthGuard, PortalRedirectGuard],
    children: [
      { path: '', component: AppsComponent },
      { path: 'home', component: HomeComponent },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'sessions',
        component: SessionsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'admin-sessions',
        component: SessionsAdminPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:sessions.manage' },
      },

      {
        path: 'system-owner',
        component: SystemOwnerPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:system:*' },
      },
      {
        path: 'systems',
        component: SystemsPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:system:*' },
      },
      {
        path: 'permissions',
        component: PermissionsPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:*' },
      },
      {
        path: 'roles',
        component: RolesPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:*' },
      },
      {
        path: 'roles/:id/permissions',
        component: RolePermissionsPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:*' },
      },
      {
        path: 'users',
        component: UsersPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:*' },
      },
      {
        path: 'insurance-users',
        component: UsersPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permission: 'perm:auth:*',
          portalSystemKey: 'insurance',
          relaxedEmployeeBranch: true,
          pageTitleKey: 'INSURANCE_USERS.TITLE',
          pageSubtitleKey: 'INSURANCE_USERS.SUBTITLE',
        },
      },
      {
        path: 'patient-users',
        component: UsersPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permission: 'perm:auth:*',
          portalSystemKey: 'patient',
          portalEntityType: 'patient',
          relaxedEmployeeBranch: true,
          pageTitleKey: 'PATIENT_USERS.TITLE',
          pageSubtitleKey: 'PATIENT_USERS.SUBTITLE',
        },
      },
      {
        path: 'doctor-users',
        component: UsersPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permission: 'perm:auth:*',
          portalSystemKey: 'doctor',
          portalEntityType: 'doctor',
          relaxedEmployeeBranch: true,
          pageTitleKey: 'DOCTOR_USERS.TITLE',
          pageSubtitleKey: 'DOCTOR_USERS.SUBTITLE',
        },
      },
      {
        path: 'referral-lab-users',
        component: UsersPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permission: 'perm:auth:*',
          portalSystemKey: 'referrallab',
          portalEntityType: 'referrallab',
          relaxedEmployeeBranch: true,
          pageTitleKey: 'REFERRAL_LAB_USERS.TITLE',
          pageSubtitleKey: 'REFERRAL_LAB_USERS.SUBTITLE',
        },
      },
      {
        path: 'groups',
        component: GroupsPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:auth:*' },
      },
      {
        path: 'settings',
        component: SettingsPage,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permission: 'perm:system:*' },
      },
      {
        path: 'login-attempts',
        component: LoginAttemptsPage,
        canActivate: [AuthGuard, PermissionGuard],
      },
      // Default redirect: Apps page for all users (shows available systems)
      // { path: '', pathMatch: 'full', redirectTo: '' }, // Already handled by AppsComponent
    ],
  },

  { path: '**', redirectTo: '' },
];
